<template>
  <v-row>
    <v-col cols="12" class="mx-auto" transactions>
      <v-card class="elevation-0">
        <Paging
          :resourceSettings="resourceSettings"
          :resource="transactions"
          @loadResource="loadResource"
          @pageByNumber="pageByNumber"
        />
        <v-card-text>
          <v-row>
            <v-col md="4" cols="12" FILTERS>
                <v-autocomplete
                  @change="applyFilter"
                  label="Done"
                  autocomplete="disabled"
                  outlined
                  dense
                  v-model="done"
                  :items="statuses"
                  :class="`${arabic?'arFont':'enFont'}`"
                />
            </v-col>
            <v-col md="4" cols="12" FILTERS>
                <v-autocomplete
                  @change="applyFilter"
                  label="Approved"
                  autocomplete="disabled"
                  outlined
                  dense
                  v-model="approved"
                  :items="statuses"
                  :class="`${arabic?'arFont':'enFont'}`"
                />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="1" class="mx-auto">
              <v-btn block @click.stop="$emit('openDialog', 'transaction')" color="primary">
                {{ i18n.new }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="transactions.data && transactions.data.length > 0">
            <v-col cols="12" class="mb-2 py-0">
              <v-timeline dense clipped>
                <v-timeline-item
                  v-for="(transaction, key) in transactions.data"
                  :key="`call-${key}`"
                  :color="transaction.done || transaction.approved ? 'success' : 'red'"
                  icon-color="grey lighten-2"
                  small
                >
                  <v-row justify="space-between" class="align-center elevation-2">
                    <v-col cols="12" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px; font-weight:700;">
                        {{ i18n.employee_name }}
                      </div>
                      <v-chip dark color="info" label small :class="`${arabic ? 'arFont' : 'enFont'}`">
                        {{ transaction.employee_name.name }}
                      </v-chip>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n.status }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">
                        <v-chip
                          dark
                          pill
                          :color="transaction.done || transaction.approved ? 'success' : 'red'"
                          small
                          :class="`${arabic ? 'arFont' : 'enFont'}`"
                        >
                          {{
                            transaction.done
                              ? i18n.transaction_done
                              : transaction.approved
                              ? i18n.transaction_done
                              : i18n.pending
                          }}
                        </v-chip>
                      </div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n.transaction_deadline }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ getFormat(transaction.deadline) }}</div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFofnt'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n.transaction_amount }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">
                        {{ transaction.ammount }} {{ transaction.currency }}
                      </div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n.last_update }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ getFormat(transaction.updated_at) }}</div>
                    </v-col>
                    <v-col cols="12" v-if="transaction.note" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n["note"] }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ transaction.note }}</div>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                      <v-row>
                        <v-col class="py-0">
                          <div>
                            <v-btn small @click.prevent="$emit('editResource', 'transaction', transaction)" class="mr-2" color="primary">
                              Edit
                            </v-btn>
                            <v-btn small @click.prevent="$emit('deleteResource', 'transaction', transaction)" color="error">Delete</v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { format } from "timeago.js";
import Paging from "@/components/Paging";

export default {
  components: { Paging },
  props: ["transactions"],
  data() {
    return {

      page: 1, 

      statuses: [
        {
          text: 'All',
          value: null,
        },
        {
          text: 'Yes',
          value: true,
        },
        {
          text: 'No',
          value: false,
        },
      ],

      // @s filters
      done: null,
      approved: null,
      // @e filters

      resourceSettings: {
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
    };
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    buildFilter() {
      let filter = ``

      if(this.done != null) {
        filter += `&done=${this.done}`
      }

      if(this.approved != null) {
        filter += `&approved=${this.approved}`
      }

      return filter;
    },
    applyFilter() {
      this.loadResource()
    },
    getFormat(d) {
      return format(d);
    },
    formatDateToCurrentLocale(date) {
      let new_date = new Date(date);
      return [
        new_date.toLocaleDateString(this.arabic ? "ar" : "en", {
          day: "numeric",
          year: "numeric",
          month: "short",
        }),
        new_date.toLocaleTimeString(this.arabic ? "ar" : "en"),
      ];
    },
    firstLettersName(name) {
      const split_names = name.split(" ");

      if (split_names.length > 1) return (split_names[0][0] + split_names[1][0]).toUpperCase();

      return (split_names[0][0] + split_names[0][1]).toUpperCase();
    },
    loadResource() {
      this.$emit("loadResource", "transactions", "transactions", this.buildFilter(), this.page);
    },
    pageByNumber(page) {
      this.page = page
      this.$emit("pageByNumber", "transactions", "transactions", page);
    },
  },
};
</script>
